<template>
  <a-modal 
    class="process-modal"
    v-model="visible" 
    title="进度详情"
    :destroyOnClose="true"
    @ok="close()"
  >
    <a-timeline class="process-timeline">
      <template v-for="(item,i) in info.timeline">
        <a-timeline-item class="item" :key="i">
          <h4>{{ item.post_status_name }}</h4>
          <p>{{ item.post_status_desc }}</p>
          <p>{{ item.created_at }}</p>
        </a-timeline-item>
      </template>
    </a-timeline>
  </a-modal>
</template>

<script>
export default {
  name: "ProcessModal",
  data() {
    return {
      visible: false,
      info: {}
    }
  },
  methods: {
    async show(item) {
      this.info = {}
      this.visible = true;
      this.info = item
    },
    close() {
      this.visible = false;
    },
  },

};
</script>

<style lang="scss" scoped>
.process-modal {

  .item { 
    h4 {
      color: #333;
      font-size: 16px;
    }
    p {
      font-size: 12px;
      color: #999;
      margin-bottom: 5px;
    }
  }
}
</style>
